module.exports = new __parcel__URL__("Planet_B_teaser_ko.25a899a4.webp").toString();